import React, { useState, useEffect } from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import cookies from "js-cookie";
import axios from "axios";
import jwtDecode from "jwt-decode";
import * as actionTypes from "./../store/actions/actionTypes";

const PrivateRouteWrapper = ({ component: Component, ...rest }) => {
  const [validToken, setValidToken] = useState(true);
  const [role, setRole] = useState(null);

  let location = useLocation();
  useEffect(() => {
    const checkToken = async () => {
      let valid = false;
      let jwt = cookies.get("token");
      if (jwt) {
        setRole(jwtDecode(jwt)?.role)
        // post request to check if token stored in cookie is valid
        try {
          let res = await axios.post(`${process.env.REACT_APP_API_HOST}/user/token/verify`, null, { withCredentials: true });
          if (res.status === 200 && res.data.status === "ok") {
            if (rest.roles) {
              // console.log("check user role is " + rest.roles);
              // check if role of valid jwt is admin or higher
              let token = jwtDecode(jwt);
              if (rest.roles.includes(token.role)) {
                valid = true;
                localStorage.setItem("name", JSON.stringify(token.user));
                localStorage.setItem("role", JSON.stringify(token.role));
                if (token.id !== rest.userId) {
                  rest.setUser(token.id, token.user);
                }
              } else {
                console.log("not valid role");
              }
            } else {
              // console.log("only check valid user");
              valid = true;
            }
          }
        } catch (err) {
          console.log("Invalid token");
        }
      }
      setValidToken(valid);
    };
    checkToken();
  });

  return (
    // Show component only if user is logged in, otherwise redirect to login page
    <Route
      {...rest}
      render={(props) => 
        validToken ? (
          <Component {...props} />
          )
        : role === 5 ?(
          <Redirect to={{ pathname: "/dashboard/admin/communication"}} />
        ) : role === 4 ?(
          <Redirect to={{ pathname: "/dashboard/map"}} />
        ) : role === 2 ? (
          <Redirect to={{ pathname: "/dashboard/admin/drive"}} />
        )
        : (
          <Redirect to={{ pathname: "/dashboard/login", state: { calledFrom: location.pathname } }} />
        )
      }
    />
  );
};

const mapStateToProps = (state) => {
  return {
    userId: state.user.id
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUser: (id, name) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        user: {
          id: id,
          name: name
        }
      });
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRouteWrapper);